module.exports = __webpack_public_path__ + "img/lemon_meringue_pie.fb50d432.jpg";